const getters = {
  getShopCategories: (state) => {
    return state.shopCategories;
  },
  getShopTypes: (state) => {
    return state.shopTypes;
  },
  getShopLocations: (state) => state.shopLocations,
  getProductCategories: (state) => {
    return state.productCategories;
  },

  getUserList: state => {
    return state.userList
  },
  getUserPageInfo: state => {
    return state.userPageInfo
  },
  getStoreAccounts: state => {
    return state.storeAccounts
  },
  getCheckedList: state => {
    return state.checkedList
  }
};

export default getters;
